import React from 'react';
import ModernHero from '../components/ModernHero/ModernHero';
import ModernServices from '../components/ModernServices/ModernServices';
import ModernWhyChooseUs from '../components/ModernWhyChooseUs/ModernWhyChooseUs';
import WebsiteOverview from '../components/WebsiteOverview/WebsiteOverview';
import FeaturedProjects from '../components/FeaturedProjects';
import Testimonials from '../components/Testimonials';

const LandingPage = () => {
  return (
    <>
      <ModernHero />
      <ModernServices />
      <ModernWhyChooseUs />
    </>
  );
}

export default LandingPage;
